module.exports = __webpack_public_path__ + "img/vertical_5_1_5012.dd30ad5e.png";